import { Navigate, useLocation } from "react-router-dom";

const RequireSchoolCode = ({ children }) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const schoolCode = params.get("school_code");

  if (!schoolCode) {
    return <Navigate to="/auth/register" replace />;
  }

  return children;
};

export default RequireSchoolCode;
